export default "__VITE_ASSET__9976122d__"